<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-comprehensive-evaluation`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M45.193 17.922L25.15 3.374a1.96 1.96 0 00-2.302 0L2.807 17.922a1.955 1.955 0 00-.711 2.187l7.655 23.54A1.958 1.958 0 0011.613 45h24.774c.848 0 1.6-.546 1.862-1.352l7.655-23.54a1.955 1.955 0 00-.711-2.186zm-38.934 2.33L24 7.373l17.74 12.878-6.776 20.836H13.036L6.259 20.251zm18.369-6.056l10.932 7.62c.374.261.53.724.388 1.146l-4.176 12.33a1.065 1.065 0 01-1.016.708H17.244c-.463 0-.873-.286-1.016-.708l-4.176-12.33a1.002 1.002 0 01.388-1.146l10.932-7.62c.375-.261.881-.261 1.256 0zm-7.794 9.623L24 18.824l7.166 4.995-2.737 8.083H19.57l-2.737-8.083z"/></svg>
</template>
<script>

export default {
  name: 'IconComprehensiveEvaluation',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
